import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { api } from "../lib/api";
import Logo from "./Logo";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api("/settings").then(setSettings).catch(() => {});
  }, []);

  const items = settings?.nav_items || [];

  return (
    <footer data-testid="site-footer" className="bg-ink text-cream mt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-6 font-elegant italic text-2xl md:text-3xl text-cream/80 max-w-sm">
              {settings?.footer_tagline || "Wedding stories, ideas and conversations worth remembering."}
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-champagne mb-5">Explore</p>
            <ul className="space-y-3">
              {items.map((item, i) => (
                <li key={i}>
                  <Link to={item.href} className="text-sm text-cream/70 hover:text-champagne transition-colors duration-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-champagne mb-5">Follow The House</p>
            <div className="flex items-center gap-4">
              {settings?.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"
                  className="w-11 h-11 rounded-full border border-cream/20 flex items-center justify-center hover:bg-champagne hover:text-ink hover:border-champagne transition-colors duration-300" aria-label="Instagram">
                  <Instagram size={18} />
                </a>
              )}
              {settings?.facebook_url && (
                <a href={settings.facebook_url} target="_blank" rel="noreferrer" data-testid="footer-facebook-link"
                  className="w-11 h-11 rounded-full border border-cream/20 flex items-center justify-center hover:bg-champagne hover:text-ink hover:border-champagne transition-colors duration-300" aria-label="Facebook">
                  <Facebook size={18} />
                </a>
              )}
            </div>
            <Link to="/admin" data-testid="footer-admin-link" className="inline-block mt-8 text-[10px] font-bold uppercase tracking-[0.25em] text-cream/50 hover:text-champagne transition-colors duration-300">
              Login
            </Link>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-display text-xl md:text-2xl text-cream/40">The Brides of India</p>
          <p className="text-xs text-cream/40 tracking-wide">© 2026 The Brides of India. Born in Mumbai, read everywhere love gathers.</p>
        </div>
      </div>
    </footer>
  );
}
